import { render } from "./MarcasXProductoView.vue?vue&type=template&id=1555d441"
import script from "./MarcasXProductoView.vue?vue&type=script&lang=js"
export * from "./MarcasXProductoView.vue?vue&type=script&lang=js"

import "./MarcasXProductoView.vue?vue&type=style&index=0&id=1555d441&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__